import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 3000 909.8"},
  viewBox: "0 0 3000 909.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2777 236.6v84.3c-47.8-61.3-117.2-99.6-199.6-99.6-159 0-282.2 142.2-282.2 317.7s123.2 317.7 282.2 317.7c88.2 0 161.5-43.8 209.4-112.8v97.6h152.1V236.6H2777zm-160.1 468.6c-88.4 0-160-74.4-160-166.2s71.6-166.2 160-166.2 160 74.4 160 166.2-71.6 166.2-160 166.2zM912.5 68.7h161.8v772.7H912.5V68.7zm347.9 429.9c0-166.3 102.1-277.2 243.5-277.2 87.8 0 157.2 39 199 105.5 41.9-66.5 111.2-105.5 199-105.5 141.4 0 243.5 110.9 243.5 277.2v342.9h-161.8V481.1c0-64.9-43-107.2-99.9-107.2s-99.9 42.4-99.9 107.2v360.4H1622V481.1c0-64.9-43-107.2-99.9-107.2s-99.9 42.4-99.9 107.2v360.4h-161.8V498.6zM619.5 242.9C581.2 99.4 500.2 53.5 423.1 53.5S265 99.4 226.7 242.9L60.4 841.6h163.9c26.7-100 109-155.7 198.8-155.7s172.1 55.8 198.8 155.7h164L619.5 242.9zM423.1 546.4c-52.2 0-99.5 19.8-134.4 51.9l94-348.4c9-33.3 22.3-43.9 40.5-43.9s31.5 10.6 40.5 43.9l93.9 348.4c-34.9-32.1-82.3-51.9-134.5-51.9z",
      style: {"fill":"#fff"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "alma-logo-white"}) } }